import { render, staticRenderFns } from "./ActionSupport.vue?vue&type=template&id=5e7d07f9&scoped=true"
import script from "./ActionSupport.vue?vue&type=script&lang=js"
export * from "./ActionSupport.vue?vue&type=script&lang=js"
import style0 from "./ActionSupport.vue?vue&type=style&index=0&id=5e7d07f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7d07f9",
  null
  
)

export default component.exports